<template>
  <div v-if="isLoading" class="skeleton-loader"></div>
  <!--Evento emitido ao clicar no card 
      @event click
  -->
  <v-card
    v-else
    dark
    class="zoox-component zoox-filter-item"
    width="100%"
    :color="color"
    @click="$emit('click')"
  >
    <span class="label">{{ label }}</span>
    <span class="value">{{ value }}</span>
    <v-icon class="icon" @click="onClick">
      {{ removeIcon }}
    </v-icon>
  </v-card>
</template>

<script>
/**
 * @displayName Filter Item Card
 */
export default {
  name: 'ZFilterItemCard',
  props: {
    /**
     * Label do item de filtro
     */
    label: {
      type: String,
      required: true,
    },
    /**
     * Valor do item de filtro
     */
    value: {
      type: String,
      required: true,
    },

    /**
     * ícone aplicado ao botão de remoção
     */
    removeIcon: {
      type: String,
      default: '$remove_circle_outline_rounded',
    },

    /**
     * Cor do item de filtro
     */
    color: {
      type: String,
      default: 'primary',
    },
    /**
     * Define o estado de loading no componente
     */
    isLoading: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    onClick() {
      /**
       * Evento emitido clicar no ícone de remoção do item de filtro
       */
      this.$emit('remove')
    },
  },
}
</script>

<style lang="scss" scoped>
.zoox-filter-item {
  display: grid;
  border-radius: var(--component-card-radius) !important;
  padding: 0px 10px;
  min-height: 45px;
  grid-template-rows: 1fr 1fr;
  grid-template-columns: 1fr 30px;

  .label {
    grid-column: 1 / 2;
    grid-row: 1 / 2;
    justify-self: start;
    color: var(--white);
  }

  .value {
    grid-column: 1 / 2;
    grid-row: 2 / 3;
    justify-self: start;
    font-weight: bold;
    font-size: 0.875rem;
  }

  .icon {
    grid-column: 2 / -1;
    grid-row: 1 / 3;
    justify-self: flex-end;
    align-self: center;
  }
}

.skeleton-loader {
  border-radius: var(--component-card-radius);
  background: rgba(0, 0, 0, 0.12);
  height: 50px;
  width: 100%;
  position: relative;

  &::after {
    content: '';
    height: 100%;
    width: 100%;
    border-radius: var(--component-card-radius);
    background: linear-gradient(
      90deg,
      hsla(0, 0%, 100%, 0),
      hsla(0, 0%, 100%, 0.5),
      hsla(0, 0%, 100%, 0)
    );
    position: absolute;
    transform: translateX(-40%);
    left: 0;
    right: 0;
    top: 0;
    animation: loading 1.5s ease-in-out infinite alternate;
  }
}

@keyframes loading {
  100% {
    transform: translateX(40%);
  }
}
</style>
